import commonUtil from '@/components/commonutil.js'
import constants from '@/components/constants.js'

const commonUtil2 = {
    ROOT_NODE_ID: 1,

    LICENSE_CATEGORY_NUMBER: 1,
    LICENSE_CATEGORY_USAGE: 2,
    LICENSE_CATEGORY_CHARGED: 3,
    goLogin(){
        window.location.href = "/static/pc/login.html";
    },
    arraysEqual(a, b) {
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (a.length != b.length) return false;

        for (var i = 0; i < a.length; ++i) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    },
    getGmoMemberId(tenantId) {
        return 'al' + ('0000000000' + tenantId).slice(-10)
    },
    getLicenseCategory(licenseType) {
        if (licenseType < 100 || 1000 < licenseType)  {
            return this.LICENSE_CATEGORY_NUMBER
        } else {
            switch (licenseType) {
                case constants.RECURRING_SPEECH_TEXT:
                case constants.RECURRING_TRANSLATION:
                    return this.LICENSE_CATEGORY_USAGE
                case constants.CHARGE_SPEECH_TEXT:
                case constants.CHARGE_TRANSLATION:
                    return this.LICENSE_CATEGORY_CHARGED
                default:
                    break;
            }
        }

        return null
    },
    getLicenseCategoryName(i18n, licenseCategory) {
        switch (licenseCategory) {
            case this.LICENSE_CATEGORY_NUMBER:
                return commonUtil.getMessageText(i18n, "item_license_basic")
            case this.LICENSE_CATEGORY_USAGE:
                return commonUtil.getMessageText(i18n, "item_license_recurring")
            case this.LICENSE_CATEGORY_CHARGED:
                return commonUtil.getMessageText(i18n, "item_license_charge")
            default:
                break;
        }

        return null
    },
    isReadOnlyUser(rootNodeInfo, tgtUserId) {
        let acl = JSON.parse(rootNodeInfo.acl)
        if (typeof acl.ro === 'undefined') return false
        for (const roAcl of acl.ro) {
            // let tenantId = roAcl.split("-")[0];
            let userId = roAcl.split("-")[1];
            if (tgtUserId === Number(userId)) {
                return true
            }
        }
        return false
    },
    isReadWriteUser(rootNodeInfo, tgtUserId) {
        let acl = JSON.parse(rootNodeInfo.acl)
        if (typeof acl.rw === 'undefined') return false
        for (const roAcl of acl.rw) {
            // let tenantId = roAcl.split("-")[0];
            let userId = roAcl.split("-")[1];
            if (tgtUserId === Number(userId)) {
                return true
            }
        }
        return false
    },
    getAclKey(tenantId, user) {
        return String(tenantId) + "-" + user.userId
    },
    getPriceInfo(licenseType, priceInfoList){
        for (let priceInfo of priceInfoList) {
            if (priceInfo.type == licenseType) {
                return priceInfo
            }
        }
    },
    getUnitPrice(purchasePeriodType, priceInfo){
        if(priceInfo.type < 100 || 1000 <= priceInfo.type ){
            switch (purchasePeriodType) {
                case constants.PURCHASE_PERIOD_MONTHLY:
                    return priceInfo.monthPrice
                case constants.PURCHASE_PERIOD_YEARLY:
                    return priceInfo.yearPrice
                case constants.PURCHASE_PERIOD_TRIAL:
                    return null
                default:
                    return null
            }
        } else if ((priceInfo.type == constants.RECURRING_SPEECH_TEXT) ||
                            (priceInfo.type == constants.RECURRING_TRANSLATION) ||
                            (priceInfo.type == constants.CHARGE_SPEECH_TEXT) ||
                            (priceInfo.type == constants.CHARGE_TRANSLATION)) {
            return priceInfo.usagePrice
        } else {
            return null
        }
    },
    getTermPrice(purchasePeriodType, priceInfo){
        switch (purchasePeriodType) {
            case constants.PURCHASE_PERIOD_MONTHLY:
                return this.getUnitPrice(purchasePeriodType, priceInfo)
            case constants.PURCHASE_PERIOD_YEARLY:
                if (priceInfo.type < 100 || 1000 <= priceInfo.type) {
                    return this.getUnitPrice(purchasePeriodType, priceInfo) * 12
                } else {
                    return this.getUnitPrice(purchasePeriodType, priceInfo)
                }
            case constants.PURCHASE_PERIOD_TRIAL:
                return null
            default:
                return null
        }
    },
    isOnlinePurchase(basicContract){
        if (basicContract.billingType == constants.BILLING_CREDIT_CARD ||
            basicContract.billingType == constants.BILLING_UNDEFINED) {
            return true
        } else {
            return false
        }
    },
    isEnableUserOption(type, user){
        return ((user.optionFlag & (1 << type)) !== 0)
    },
    isEnableTalkgroupOption(type, talkgroup){
        return ((talkgroup.optionFlag & (1 << type)) !== 0)
    },
    getTrialContractMap(basicContract){
        return {
            enableSpeechTextTrial: ((basicContract.optionTrial & constants.TRIAL_OPTION_SPEECH_TEXT) != 0),
            enableTranslationTrial: ((basicContract.optionTrial & constants.TRIAL_OPTION_TRANSLATION) != 0),
            enableVideoTrial: ((basicContract.optionTrial & constants.TRIAL_OPTION_VIDEO) != 0),
            enableConfigTrial: ((basicContract.optionTrial & constants.TRIAL_OPTION_CONFIG) != 0),
            enableTrackingTrial: ((basicContract.optionTrial & constants.TRIAL_OPTION_TRACKING) != 0),
            enableMaptalkTrial: ((basicContract.optionTrial & constants.TRIAL_OPTION_MAP_TALK) != 0)
        }
    },
    isLicenseEnableForTrial(basicContract, licenseType){
        let enable = false
        switch(Number(licenseType)) {
            case constants.LICENSE_SPEECH_TEXT :
                enable = ((basicContract.optionTrial & constants.TRIAL_OPTION_SPEECH_TEXT) != 0)
                break;
            case constants.LICENSE_TRANSLATION :
                enable = ((basicContract.optionTrial & constants.TRIAL_OPTION_TRANSLATION) != 0)
                break;
            case constants.LICENSE_CONFIG :
                enable = ((basicContract.optionTrial & constants.TRIAL_OPTION_CONFIG) != 0)
                break;
            case constants.LICENSE_TRACKING :
                enable = ((basicContract.optionTrial & constants.TRIAL_OPTION_TRACKING) != 0)
                break;
            case constants.LICENSE_MAP_TALK :
                enable = ((basicContract.optionTrial & constants.TRIAL_OPTION_MAP_TALK) != 0)
                break;
            case constants.LICENSE_SAML :
                enable = ((basicContract.optionTrial & constants.TRIAL_OPTION_SAML) != 0)
                break;
        }
        return enable
    },
    getContractMapFromList(numberContractList){
        let contractMap = {}

        for (let license of numberContractList) {
            switch(Number(license.type)) {
                case constants.LICENSE_SPEECH_TEXT :
                    contractMap.enableSpeechTextOption = (license.currentMax > 0)
                    break;
                case constants.LICENSE_TRANSLATION :
                    contractMap.enableTranslationOption = (license.currentMax > 0)
                    break;
                case constants.LICENSE_CONFIG :
                    contractMap.enableConfigOption = (license.currentMax > 0)
                    break;
                case constants.LICENSE_TRACKING :
                    contractMap.enableTrackingOption = (license.currentMax > 0)
                    break;
                case constants.LICENSE_MAP_TALK :
                    contractMap.enableMaptalkOption = (license.currentMax > 0)
                    break;
                case constants.LICENSE_VIDEO :
                    contractMap.enableVideoOption = (license.currentMax > 0)
                    break;
                case constants.LICENSE_SAML :
                    contractMap.enableSamlOption = (license.currentMax > 0)
                    break;
            }
        }

        return contractMap
    },
    getUserOptionMap(i18n, basicContract){
        if (this.isOnlinePurchase(basicContract)) {
            return commonUtil.getUserOptionForOnline(i18n);
        } else {
            return commonUtil.getUserOption(i18n);
        }
    },
    getDefaultUserOptions(i18n, basicContract) {

        let userOptionMap = this.getUserOptionMap(i18n, basicContract)

            let userOptions = [];
            for (var i = 0 ; i < userOptionMap.length ; i++ ) {
                userOptions.push(
                        {
                                displayName: userOptionMap[i].name,
                                shift: userOptionMap[i].shift,
                                value: false
                        });
            }

            return userOptions
    },
    createUserOptionObjs(i18n, basicContract, userOptions) {
            let ret = []

            if (commonUtil.isVisibleUserOption(this.isOnlinePurchase(basicContract), 'speechToText')) {
                ret.push({
                    shift: constants.USER_OPTION_SPEECH_TEXT,
                    value: userOptions.speechToText,
                    displayName: commonUtil.getMessageText(i18n, "item_option_speechToText")
                })
            }
            if (commonUtil.isVisibleUserOption(this.isOnlinePurchase(basicContract), 'translation')) {
                ret.push({
                    shift: constants.USER_OPTION_TRANSLATION,
                    value: userOptions.translation,
                    displayName: commonUtil.getMessageText(i18n, "item_option_translation")
                })
            }
            if (commonUtil.isVisibleUserOption(this.isOnlinePurchase(basicContract), 'tracking')) {
                ret.push({
                    shift: constants.USER_OPTION_TRACKING,
                    value: userOptions.tracking,
                    displayName: commonUtil.getMessageText(i18n, "item_option_location_tracking")
                })
            }
            if (commonUtil.isVisibleUserOption(this.isOnlinePurchase(basicContract), 'mapTalk')) {
                ret.push({
                    shift: constants.USER_OPTION_MAP_TALK,
                    value: userOptions.mapTalk,
                    displayName: commonUtil.getMessageText(i18n, "item_option_map_talk")
                })
            }
            if (commonUtil.isVisibleUserOption(this.isOnlinePurchase(basicContract), 'video')) {
                ret.push({
                    shift: constants.USER_OPTION_VIDEO,
                    value: userOptions.video,
                    displayName: commonUtil.getMessageText(i18n, "item_option_video")
                })
            }

            return ret
    },
    getNewUserOption (userOptions, orgUserOptions) {
        let newUserOption = {};
        userOptions.forEach( function( option ) {
            switch (option.shift) {
                case constants.USER_OPTION_SPEECH_TEXT:
                    if (orgUserOptions === null || option.value != orgUserOptions.speechToText) {
                        newUserOption.speechToText = option.value
                    }
                    break;
                case constants.USER_OPTION_TRANSLATION:
                    if (orgUserOptions === null || option.value != orgUserOptions.translation) {
                        newUserOption.translation = option.value
                    }
                    break;
                case constants.USER_OPTION_TRACKING:
                    if (orgUserOptions === null || option.value != orgUserOptions.tracking) {
                        newUserOption.tracking = option.value
                    }
                    break;
                case constants.USER_OPTION_MAP_TALK:
                    if (orgUserOptions === null || option.value != orgUserOptions.mapTalk) {
                        newUserOption.mapTalk = option.value
                    }
                    break;
                case constants.USER_OPTION_VIDEO:
                    if (orgUserOptions === null || option.value != orgUserOptions.video) {
                        newUserOption.video = option.value
                    }
                    break;

                default:
                    break;
            }
        }, this);

        if (Object.keys(newUserOption).length == 0) {
            newUserOption = null;
        }

        return newUserOption;
    },
    removePrivilege(rights, tgtPrivilege) {
        let newRights = ""
        let privilegeList = rights.split(",")

        for (let privilege of privilegeList) {
            if (privilege != tgtPrivilege) {
                if (newRights != "") {
                    newRights += ","
                }
                newRights += privilege
            }
        }

        return newRights
    },
    addPrivilege(rights, tgtPrivilege) {
        let newRights = rights

        if (rights === null || rights === "") {
            newRights = tgtPrivilege
        } else {
            newRights = rights + "," + tgtPrivilege
        }

        return newRights
    },
    isBasicOption(shift) {
        let basicOption = false
        switch (shift) {
            case constants.TALKGROUP_OPTION_MULTI_TALK:
            case constants.TALKGROUP_OPTION_LOCATION:
                basicOption = true
                break;
            default:
                break;
        }

        return basicOption
    },
    createTalkgroupOptionObjs(i18n, basicContract, talkgroupOptions, e2eEncryption) {
        var ret = []
        if (commonUtil.isVisibleGroupOption(this.isOnlinePurchase(basicContract), "multi")) {
            ret.push({
                shift: constants.TALKGROUP_OPTION_MULTI_TALK,
                value: talkgroupOptions.multi,
                displayName: commonUtil.getMessageText(i18n,"item_option_fullDuplexCall"),
                basicOptions: true
            })
        }
        if (commonUtil.isVisibleGroupOption(this.isOnlinePurchase(basicContract), "location")) {
            ret.push( {
                shift: constants.TALKGROUP_OPTION_LOCATION,
                value: talkgroupOptions.location,
                displayName: commonUtil.getMessageText(i18n,"item_option_location_information"),
                basicOptions: true
            })
        }
        if (commonUtil.isVisibleGroupOption(this.isOnlinePurchase(basicContract), "mapTalk")) {
            ret.push( {
                shift: constants.TALKGROUP_OPTION_MAP_TALK,
                value: talkgroupOptions.mapTalk,
                displayName: commonUtil.getMessageText(i18n,"item_option_map_talk"),
                basicOptions: false
            })
        }
        if (!e2eEncryption && commonUtil.isVisibleGroupOption(this.isOnlinePurchase(basicContract), "speechToTextEngine")) {
            ret.push({
                shift: constants.TALKGROUP_OPTION_SPEECH_TEXT,
                value: (talkgroupOptions.speechToTextEngine) > 0 ? true : false,
                engine: this.getTgOptionEngineInfo(i18n, constants.TALKGROUP_OPTION_SPEECH_TEXT, talkgroupOptions.speechToTextEngine),
                displayName: commonUtil.getMessageText(i18n,"item_option_speechToText"),
                basicOptions: false
            })
        }
        if (!e2eEncryption && commonUtil.isVisibleGroupOption(this.isOnlinePurchase(basicContract), "translationEngine")) {
            ret.push({
                shift: constants.TALKGROUP_OPTION_TRANSLATION,
                value: (talkgroupOptions.translationEngine) > 0 ? true : false,
                engine: this.getTgOptionEngineInfo(i18n, constants.TALKGROUP_OPTION_TRANSLATION, talkgroupOptions.translationEngine),
                displayName: commonUtil.getMessageText(i18n,"item_option_translation"),
                basicOptions: false
            })
        }

        if (commonUtil.isVisibleGroupOption(this.isOnlinePurchase(basicContract), "video")) {
            ret.push( {
                shift: constants.TALKGROUP_OPTION_VIDEO,
                value: talkgroupOptions.video,
                displayName: commonUtil.getMessageText(i18n,"item_option_video"),
                basicOptions: false
            })
        }

        return ret
    },
    addTalkgroupOptionCopyForOrgData(talkgroupOptions) {
        talkgroupOptions.forEach( ( go ) => {
            go.orgValue = go.value
            if (this.isEngineSelectable(go.shift)) {
                go.orgEngine = {type: go.engine.type}
            }
        });
    },
    getTalkgroupBasicOptions(talkgroupOptions) {
            let basicTalkgroupOptions = []

            for (let i = 0; i < talkgroupOptions.length; i++) {
                const talkgroupOption = talkgroupOptions[i]
                if (talkgroupOption.basicOptions) {
                    basicTalkgroupOptions.push(talkgroupOption)
                }
            }

            return basicTalkgroupOptions
    },
    getDefaultTalkgroupOptions(i18n, basicContract) {
        let tmpTalkgroupOptions = commonUtil.getTalkgroupOption(i18n);
        return this.migrateTalkgroupOptions(i18n, tmpTalkgroupOptions)
    },
    getTalkgroupOptionsAvailableForE2EEncryption(i18n, basicContract) {
        let tmpTalkgroupOptions = commonUtil.getTalkgroupOptionAvailableForE2EEncryption(i18n);
        return this.migrateTalkgroupOptions(i18n, tmpTalkgroupOptions)
    },
    migrateTalkgroupOptions(i18n, tmpTalkgroupOptions) {
        let talkgroupOptions = [];
        for (var i = 0 ; i < tmpTalkgroupOptions.length ; i++ ) {
            let addOption = {
                displayName: tmpTalkgroupOptions[i].name,
                shift: tmpTalkgroupOptions[i].shift,
                value: false,
                basicOptions: this.isBasicOption(tmpTalkgroupOptions[i].shift)
            }

            if (this.isEngineSelectable(tmpTalkgroupOptions[i].shift)) {
                let tgOptionEngine = this.getTgOptionEngineInfo(i18n, tmpTalkgroupOptions[i].shift, 0)
                addOption.engine = tgOptionEngine
            }

            talkgroupOptions.push(addOption);
        }

        return talkgroupOptions
    },
    getTalkgroupOptionOptions(talkgroupOptions) {
        let optionTalkgroupOptions = []

        for (let i = 0; i < talkgroupOptions.length; i++) {
            const talkgroupOption = talkgroupOptions[i]
            if (!talkgroupOption.basicOptions) {
                optionTalkgroupOptions.push(talkgroupOption)
            }
        }

        return optionTalkgroupOptions
    },
    getNewTalkgroupOption (talkgroupOptions, orgTalkgroupOptions) {
        let newTalkgroupOptions = {};
        talkgroupOptions.forEach( function( option ) {
            switch (option.shift) {
                case constants.TALKGROUP_OPTION_MULTI_TALK:
                    if (orgTalkgroupOptions == null || option.value !== orgTalkgroupOptions.multi) {
                        newTalkgroupOptions.multi = option.value
                    }
                    break;
                case constants.TALKGROUP_OPTION_SPEECH_TEXT:
                    if (orgTalkgroupOptions == null || option.engine.type !== orgTalkgroupOptions.speechToTextEngine) {
                        newTalkgroupOptions.speechToTextEngine = option.engine.type
                    }
                    break;
                case constants.TALKGROUP_OPTION_TRANSLATION:
                    if (orgTalkgroupOptions == null || option.engine.type !== orgTalkgroupOptions.translationEngine) {
                        newTalkgroupOptions.translationEngine = option.engine.type
                    }
                    break;
                case constants.TALKGROUP_OPTION_LOCATION:
                    if (orgTalkgroupOptions == null || option.value !== orgTalkgroupOptions.location) {
                        newTalkgroupOptions.location = option.value
                    }
                    break;
                case constants.TALKGROUP_OPTION_MAP_TALK:
                    if (orgTalkgroupOptions == null || option.value !== orgTalkgroupOptions.mapTalk) {
                        newTalkgroupOptions.mapTalk = option.value
                    }
                    break;
                case constants.TALKGROUP_OPTION_VIDEO:
                    if (orgTalkgroupOptions == null || option.value !== orgTalkgroupOptions.video) {
                        newTalkgroupOptions.video = option.value
                    }
                    break;
                default:
                    break;
            }
        }, this);

        if (Object.keys(newTalkgroupOptions).length == 0) {
            newTalkgroupOptions = null;
        }

        return newTalkgroupOptions;
    },
    getEngineType (shift, talkgroupOptionInfo) {
        switch (shift) {
            case constants.TALKGROUP_OPTION_SPEECH_TEXT:
                if (typeof(talkgroupOptionInfo.speechToTextEngine) === "undefined") {
                    return 0
                } else {
                    return talkgroupOptionInfo.speechToTextEngine
                }
            case constants.TALKGROUP_OPTION_TRANSLATION:
                if (typeof(talkgroupOptionInfo.translationEngine) === "undefined") {
                    return 0
                } else {
                    return talkgroupOptionInfo.translationEngine
                }
            default:
                return null
        }
    },
    getEngineDisplayName(i18n, shift, engineType){
        let engineList = []
        switch (shift) {
            case constants.TALKGROUP_OPTION_SPEECH_TEXT:
                engineList = commonUtil.getSpeechToTextEngineList(i18n)
                break;
            case constants.TALKGROUP_OPTION_TRANSLATION:
                engineList = commonUtil.getTranslationEngineList(i18n)
                break;
            default:
                break;
        }

        for (const engine of engineList) {
            if (engine.type === engineType) {
                return engine.displayName
            }
        }

        return null
    },
    getTgOptionEngineInfo(i18n, shift, engineType){
        let engineList = []
        switch (shift) {
            case constants.TALKGROUP_OPTION_SPEECH_TEXT:
                engineList = commonUtil.getSpeechToTextEngineList(i18n)
                break;
            case constants.TALKGROUP_OPTION_TRANSLATION:
                engineList = commonUtil.getTranslationEngineList(i18n)
                break;
            default:
                break;
        }

        for (const engine of engineList) {
            if (engine.type === engineType) {
                return engine
            }
        }

        return null
    },
    getUseText(i18n, bool) {
        if (bool) {
            return commonUtil.getMessageText(i18n, "item_value_used")
        } else {
            return commonUtil.getMessageText(i18n, "item_value_nonUsed")
        }
    },
    isEngineSelectable (optionShift) {
        return (optionShift === constants.TALKGROUP_OPTION_SPEECH_TEXT ||
            optionShift === constants.TALKGROUP_OPTION_TRANSLATION)
    },
    getNewPlanList(i18n) {
        return [
            { type: constants.LICENSE_PLAN_TALK_LITE, name: this.getMessageText(i18n,"item_planType_talk_lite") },
            { type: constants.LICENSE_PLAN_TALK_ENT,  name: this.getMessageText(i18n,"item_planType_talk_enterprise") },
            { type: constants.LICENSE_PLAN_LIVE_ENT,  name: this.getMessageText(i18n,"item_planType_livecast_enterprise") }
        ];
    },

    PLAN_CHANGE_TYPE_EQUAL: 0,
    PLAN_CHANGE_TYPE_UPGRADE: 1,
    PLAN_CHANGE_TYPE_DOWNGRADE: 2,
    getPlanChangeType(oldPlanType, newPlanType) {
        if (oldPlanType === newPlanType) {
            return this.PLAN_CHANGE_TYPE_EQUAL
        }

        if (oldPlanType === constants.LICENSE_PLAN_TALK_LITE) {
            return this.PLAN_CHANGE_TYPE_UPGRADE
        }

        if (oldPlanType === constants.LICENSE_PLAN_TALK_ENT) {
            if (newPlanType === constants.LICENSE_PLAN_LIVE_ENT) {
                return this.PLAN_CHANGE_TYPE_UPGRADE
            } else {
                return this.PLAN_CHANGE_TYPE_DOWNGRADE
            }
        }

        if (oldPlanType === constants.LICENSE_PLAN_LIVE_LITE) {
            if (newPlanType === constants.LICENSE_PLAN_LIVE_ENT) {
                return this.PLAN_CHANGE_TYPE_UPGRADE
            } else {
                return this.PLAN_CHANGE_TYPE_DOWNGRADE
            }
        }

        return this.PLAN_CHANGE_TYPE_DOWNGRADE
    },

    getPlanUpgradeType(oldPlanType, newPlanType) {
        if (oldPlanType === constants.LICENSE_PLAN_TALK_LITE && newPlanType === constants.LICENSE_PLAN_TALK_ENT) {
            return constants.PLAN_UPGRADE_TL_TE
        }

        if (oldPlanType === constants.LICENSE_PLAN_TALK_LITE && newPlanType === constants.LICENSE_PLAN_LIVE_LITE) {
            return constants.PLAN_UPGRADE_TL_LL
        }

        if (oldPlanType === constants.LICENSE_PLAN_TALK_LITE && newPlanType === constants.LICENSE_PLAN_LIVE_ENT) {
            return constants.PLAN_UPGRADE_TL_LE
        }

        if (oldPlanType === constants.LICENSE_PLAN_TALK_ENT && newPlanType === constants.LICENSE_PLAN_LIVE_ENT) {
            return constants.PLAN_UPGRADE_TE_LE
        }

        if (oldPlanType === constants.LICENSE_PLAN_LIVE_LITE && newPlanType === constants.LICENSE_PLAN_LIVE_ENT) {
            return constants.PLAN_UPGRADE_LL_LE
        }

        return null
    },

    getPlanDowngradeDeferredCode(oldPlanType, newPlanType) {
        if (oldPlanType === constants.LICENSE_PLAN_TALK_ENT && newPlanType === constants.LICENSE_PLAN_TALK_LITE) {
            return constants.DEFERRED_TE_TO_TL
        }

        if (oldPlanType === constants.LICENSE_PLAN_TALK_ENT && newPlanType === constants.LICENSE_PLAN_LIVE_LITE) {
            return constants.DEFERRED_TE_TO_LL
        }

        if (oldPlanType === constants.LICENSE_PLAN_LIVE_LITE && newPlanType === constants.LICENSE_PLAN_TALK_LITE) {
            return constants.DEFERRED_LL_TO_TL
        }

        if (oldPlanType === constants.LICENSE_PLAN_LIVE_LITE && newPlanType === constants.LICENSE_PLAN_TALK_ENT) {
            return constants.DEFERRED_LL_TO_TE
        }

        if (oldPlanType === constants.LICENSE_PLAN_LIVE_ENT && newPlanType === constants.LICENSE_PLAN_LIVE_LITE) {
            return constants.DEFERRED_LE_TO_LL
        }

        if (oldPlanType === constants.LICENSE_PLAN_LIVE_ENT && newPlanType === constants.LICENSE_PLAN_TALK_ENT) {
            return constants.DEFERRED_LE_TO_TE
        }

        if (oldPlanType === constants.LICENSE_PLAN_LIVE_ENT && newPlanType === constants.LICENSE_PLAN_TALK_LITE) {
            return constants.DEFERRED_LE_TO_TL
        }

        return null
    },

    getPlanChangeRequest(deferredRequest) {
        for (let aDeferredRequest of deferredRequest) {
            if (aDeferredRequest.operationCode === constants.DEFERRED_TE_TO_TL ||
                aDeferredRequest.operationCode === constants.DEFERRED_TE_TO_LL ||
                aDeferredRequest.operationCode === constants.DEFERRED_LL_TO_TL ||
                aDeferredRequest.operationCode === constants.DEFERRED_LL_TO_TE ||
                aDeferredRequest.operationCode === constants.DEFERRED_LE_TO_LL ||
                aDeferredRequest.operationCode === constants.DEFERRED_LE_TO_TE ||
                aDeferredRequest.operationCode === constants.DEFERRED_LE_TO_TL
            ) {
                return aDeferredRequest
            }
        }
        return null
    }
}

const newCommonUtil = {
    ...commonUtil,
    ...commonUtil2
}

export default newCommonUtil;
